import React from "react";
import prettyBytes from "pretty-bytes";
import clsx from "clsx";
import { Badge, Chip, createStyles, styled, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import BusinessIcon from "@mui/icons-material/Business";
import DynamicIcon from "./DynamicIcon";
import { getMimeExtension } from "./mimeTypes";

type FileTitleProps = {
  title: string;
  mimeType: string;
  url: string;
  directory?: string;
  fileSize?: number;
  isCorporate?: boolean;
  isUnread?: boolean;
  icon?: string;
};

export const CustomChip = styled(Chip)`
  border-radius: 8px;
  font-size: 0.75rem;
  padding-left: 0;
  padding-right: 0;
  margin-left: 2px;
  background-color: #f4f4fc;
`;
export const CustomOutlinedChip = styled(Chip)`
  border-radius: 8px;
  font-size: 0.75rem;
  padding-left: 0;
  padding-right: 0;
  margin-left: 2px;
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      alignItems: "center",
      gap: "0.5rem",
      color: theme.palette.primary.main,
      textDecoration: "none",
    },
    folderIcon: {
      background: "transparent !important",
    },
    unread: {
      fontWeight: 700,
    },
  })
) as () => Record<"container" | "folderIcon" | "unread", string>;
const FileTitle = ({
  title,
  mimeType,
  url,
  directory,
  fileSize,
  isCorporate,
  isUnread,
  icon,
}: FileTitleProps) => {
  const formatedMime = getMimeExtension(mimeType) === "?" ? mimeType : getMimeExtension(mimeType);
  const classes = useStyles();

  return (
    <a
      href={url}
      title={title}
      target="_blank"
      download
      rel="noreferrer"
      className={clsx(classes.container, isUnread && classes.unread)}
    >
      <Badge
        color="error"
        invisible={!isUnread}
        variant="dot"
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <DynamicIcon iconName={icon || `File${formatedMime}`} fallback="FileUnknown" />
        &nbsp;
      </Badge>
      {isCorporate && (
        <CustomOutlinedChip
          size="small"
          label="Corporate"
          color="default"
          variant="outlined"
          icon={<BusinessIcon />}
        />
      )}
      {title}
      {directory && (
        <CustomOutlinedChip size="small" variant="outlined" color="secondary" label={directory} />
      )}
      &nbsp;
      {fileSize && fileSize > 0 && (
        <CustomOutlinedChip
          size="small"
          variant="outlined"
          color="secondary"
          label={prettyBytes(fileSize || 0)}
        />
      )}
    </a>
  );
};

export default FileTitle;
